import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  External User Services
 * !== 외부 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/xtrnusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/xtrn-usr-mgmt`,
    co_api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co`,
    nodes: [],
};

export const URLS = {
    ptli0922001q: `${BASE.path}/ptli0922001q`, // External User List !== 외부 사용자 목록 ==!
    ptli0922002s: `${BASE.path}/ptli0922002s`, // External User Registration !== 외부 사용자 등록 ==!
    ptli0922003s: `${BASE.path}/ptli0922003s`, // External User Modification !== 외부 사용자 수정 ==!
    ptli0922004q: `${BASE.path}/ptli0922004q`, // External User Details !== 외부 사용자 상세 ==!
};

export const APIS = {
    // Check External User List !==  외부 관리 목록 조회 ==!
    getXtrnUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Check External User Information !== 외부 관리 상세 정보 조회 ==!
    getXtrnUsrInfo: (xtrnUsrUuid: any) => {
        return api.get(`${BASE.api}/${xtrnUsrUuid}`);
    },
    // Create External User information !== 외부 사용자 정보 등록 ==!
    createXtrnUsrInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update External User information !== 외부 사용자 정보 수정 ==!
    updateXtrnUsrInfo: (data: any) => {
        return api.put(`${BASE.api}`, { ...data });
    },
    // Delete External User information !== 외부 사용자 정보 삭제 ==!
    deleteXtrnUsrInfo: (xtrnUsrUuid: any) => {
        return api.delete(`${BASE.api}/${xtrnUsrUuid}`);
    },
    // Reset the External User password. !== 외부 사용자 비밀번호 초기화 ==!
    updateXtrnUsrPwdInit: (data: any) => {
        return api.put(`${BASE.api}/pwd-init`, {
            ...data,
        });
    },
    // Retrieve Tin information. !== Tin 번호 정보를 조회한다 ==!
    getTinInfo: (xtrnUsrUuid: any) => {
        return api.get(`${BASE.api}/check-tin/${xtrnUsrUuid}`);
    },
    // TIN Number Search !== TIN 번호 조회 ==!
    getPayerTinNoLst: (tinNo: any, bizYn: any) => {
        return comnUtils.getCode({
            area: "payerTinNo",
            keyword: tinNo,
            param2: bizYn,
        });
    },
    // Check the External User duplicate !== 외부 사용자 중복 체크 ==!
    getXtrnDuplCheck: (xtrnUsrIdntfNo: any) => {
        return api.get(`${BASE.api}/duplchk/${xtrnUsrIdntfNo}`);
    },

    getXtrnUsrExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),

    // Revert deleted external user
    revertXtrnUsrInfo: (xtrnUsrUuid: any) => {
        return api.put(`${BASE.api}/revert/${xtrnUsrUuid}`);
    },
};

export const SF_XTRN_USR_SRCH: TFormSchema = {
    id: "form_xtrnUsrSrch",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_TIN" },
        usrNm: { type: "text", label: "L_NM" },
        arrUsrStatCd: { type: "checkbox", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001" },
        frstRgsrDtm: {
            type: "daterange",
            label: "L_RGSR_PRID",
            start: { name: "frstRgsrDtmFrom" },
            end: { name: "frstRgsrDtmTo" },
            rangeButton: 4,
        },
    },
};

export const SG_XTRN_USR_LIST: TGridSchema = {
    id: "grid_xtrnUsrList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "xtrnUsrIdntfNo", width: "20%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "20%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

export const SF_XTRN_USR_INFO: TFormSchema = {
    id: "form_usrAplyInfo",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_TIN_NO", required: true, maxLength: 9 },
        usrNm: { type: "text", label: "L_NM", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", controlSize: 10, required: true },
        usrPwd: { type: "password", label: "L_USR_PWD", required: true },
        actnCtgrCd: { type: "select", label: "L_ACTN_CTGR_CD", area: "comnCd", comnCd: "COM0021", required: true },
        usrStatCd: { type: "select", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001", required: true },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
        bidrYn: {
            type: "radio",
            label: "L_BIDR_USR",
            options: [
                { label: "No", value: "N" },
                { label: "Yes", value: "Y" },
            ],
            defaultValue: "N",
            required: true,
        },
    },
};

export const SG_XTRN_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_xtrnUsrExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "xtrnUsrIdntfNo", width: "20%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "20%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};
